import {Box, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

import {VoucherInvalidIcon} from 'assets/icons/voucherInvalid';
import Button from 'components/button/Button';
import {useAppDispatch, useAppSelector} from 'hooks';
import SendBrowserEvent from 'services/send-browser-event';
import {removePromotionVoucherAction} from 'store/actions/basket-action';
import {isSyncBasketEnabled} from 'utils/helper';

export type VoucherInvalidAlertContentProps = {
  onClose: () => void;
  onRetryCheckout: () => void;
};

export const VoucherInvalidAlertContent = (props: VoucherInvalidAlertContentProps) => {
  const {onClose, onRetryCheckout} = props;
  const dispatch = useAppDispatch();
  const {t} = useTranslation();
  const storeSelecteditems = useAppSelector((state) => state?.basket?.selectedItems);
  const localeSelectedItems = JSON.parse(localStorage.getItem('selectedItems') || '[]') || [];
  const isSyncBasket = isSyncBasketEnabled();
  const selectedItems = isSyncBasket ? storeSelecteditems : localeSelectedItems;

  const onSelectOther = () => {
    SendBrowserEvent.goToBasketVouchers(selectedItems);
    onClose();
  };

  const onContinueWithout = () => {
    dispatch(removePromotionVoucherAction(onRetryCheckout));
    onClose();
  };

  return (
    <Box flexDirection="column" display="flex" gap={2}>
      <Box alignItems="center" width="100%" display="flex" flexDirection="column" gap={1}>
        <VoucherInvalidIcon />
        <Typography color="#BA1A1A" fontSize={20} fontWeight={700}>
          {t('alerts.invalidVoucher.title')}
        </Typography>
        <Typography fontSize={16}>{t('alerts.invalidVoucher.description')}</Typography>
      </Box>
      <Button onClick={onSelectOther} shape="rounded" variant="contained">
        {t('alerts.invalidVoucher.selectOther')}
      </Button>
      <Button onClick={onContinueWithout} shape="rounded" variant="outlined">
        {t('alerts.invalidVoucher.continueWithout')}
      </Button>
    </Box>
  );
};
